import { spawn } from 'redux-saga/effects';

import { watchGetCustomerPortalLink } from './getCustomerPortalLink';

export default function* saga() {
  yield spawn(watchGetCustomerPortalLink);
}
